export interface ChatClientAvailability {
  featureEnabled?: boolean;
  routeEnabled?: boolean;
}

export const isChatClientSdkEnabled = ({
  featureEnabled,
  routeEnabled,
}: ChatClientAvailability): boolean =>
  featureEnabled === true && routeEnabled === true;

export const isUnauthInternetChatEnabled = (
  featureEnabled?: boolean
): boolean => featureEnabled === true;
